import { Box, Paper, Tab, Tabs } from '@mui/material';
import { FC, SyntheticEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATHS } from 'routes/constants';
import { COLORS } from 'services/constants/colors';

export const PPWR_SUB_MENU = [
	{ value: PATHS.PPWR_MANUAL_REPORT_PAGE, label: 'Filing Manual Reports' },
	{ value: PATHS.PPWR_PACKING_PROFILE_PAGE, label: 'Packing Profile' },
	{ value: PATHS.PPWR_COUNTRY_EXCLUSION_PAGE, label: 'Country Exclusion' },
];

export const PpwrSubMenu: FC = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const value = PPWR_SUB_MENU.find((item) => item.value === pathname)?.value ?? false;

	const handleChange = (event: SyntheticEvent, newValue: string) => {
		navigate(newValue);
	};

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<Paper
				sx={{
					m: '-16px -10px 10px -10px',
					borderRadius: '0!important',
					// Render above the AppBar (zIndex 1000) so its shadow does not fall on the sub menu.
					position: 'relative',
					zIndex: 1001,
					borderTop: `1px solid ${COLORS.PRIMARY}`,
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', p: '8px 8px' }}>
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="PPWR menu"
						sx={{
							minHeight: '20px',
							'& .MuiTabs-indicator': {
								backgroundColor: 'primary.main',
								height: '0',
							},
							'& .MuiButtonBase-root': {
								fontWeight: 'bold',
								color: COLORS.PRIMARY,
								opacity: 1,
							},
							'& .Mui-selected': {
								color: COLORS.PRIMARY,
								opacity: 0.5,
							},
						}}
					>
						{PPWR_SUB_MENU.map((item) => (
							<Tab
								key={item.value}
								value={item.value}
								label={item.label}
								sx={{ fontWeight: 'bold', p: '0 10px', minHeight: '20px' }}
							/>
						))}
					</Tabs>
				</Box>
			</Paper>
		</Box>
	);
};
